import { Products, SettlementStatus } from "enums";
import PayWithLOCQPayStatus from "enums/pay-with-locqpay-status";
export const payWithLOCQPayFilterState = () => ({
  startDate: null,
  endDate: null,
  searchKey: "",
  productCodes: [Products.Diesel, Products.Gas91, Products.Gas95, Products.Gas97],
  settlementStatuses: {
    isSelectedAll: true,
    value: [
      SettlementStatus.ForSettlement,
      SettlementStatus.ForProcessing,
      SettlementStatus.Processed,
    ],
  },
  status: {
    isSelectedAll: true,
    value: [PayWithLOCQPayStatus.Success, PayWithLOCQPayStatus.Voided],
  },
  page: 1,
  perPage: 10,
});
